import React, { useMemo, useRef } from 'react';

import { Neighborhood } from 'apolloClient/types';
import PageBuilderContentParser from '../../PageBuilderContentParser';
import { pageBuilderValidator } from 'src/utils/utils';

const AboutNeighborhood: React.FC<{ neighborhood: Neighborhood }> = ({
  neighborhood,
}) => {
  const { name, description } = neighborhood;

  const containerRef = useRef<HTMLDivElement | null>(null);
  const descriptionValidation = useMemo(
    () => pageBuilderValidator(description),
    [description]
  );
  if (!descriptionValidation.isDescriptionValid) return null;

  return (
    <>
      <div className="absolute w-screen h-[100%] z-[-1] bg-beige-light" />
      <section
        ref={containerRef}
        className="container flex flex-col items-center mt-[100px] md:mt-0 md:pb-4 md:pt-[10px] lg:py-2 lg:pb-[29px] text-m"
      >
        <div className="flex flex-col mx-auto mb-4 lg:mb-2">
          <h2 className="my-6 text-30-36-1 text-center uppercase lg:mt-6 lg:mb-16 md:text-39-47-1.3 font-sohneBreitHalbfett">
            Welcome to {name}
          </h2>
        </div>
        <div className="w-full neighborhood-builder">
          <PageBuilderContentParser
            data={descriptionValidation.cleanedDescription}
            readMore={true}
            containerRef={containerRef}
            validElementsCount={descriptionValidation.validElementsCount}
          />
        </div>
      </section>
    </>
  );
};

export default AboutNeighborhood;
